import AppInput from "@src/components/AppInput";
import { UIButton } from "@src/components/UIButton";
import UIModal from "@src/components/UIModal/UIModal";
import { useNotification } from "@src/context/NotificationContext";
import {
  useCreateFeelingTag,
  useCreateGenreTag,
  useCreateTagMutation,
} from "@src/queries/tagQueries";
import { useAppDispatch, useAppSelector } from "@src/redux/hooks";
import {
  setCreateTagModalOpen,
  setRefetchTagsByTagType,
  setTagTypeToCreate,
} from "@src/redux/slices/tagFactorySlice";
import { RootState } from "@src/redux/store";
import { IPlaylistRecord } from "@src/types/playlist";
import { ITagType } from "@src/types/tags";
import React from "react";
import { useForm } from "react-hook-form";

interface CreateTagModalProps {
  closeModal: () => void;
  isOpen: boolean;
  openModal: () => void;
  toggleModal: () => void;
  onConfirm: (data: any) => void;
  data?: IPlaylistRecord;
  tagType?: ITagType;
}

const CreateTagModal: React.FC<CreateTagModalProps> = ({
  closeModal,
  isOpen,
  onConfirm,
}) => {
  const { tagTypeToCreate: tagType } = useAppSelector(
    (state: RootState) => state.tagFactory
  );
  const {
    watch,
    reset,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ title: string }>();
  const dispatch = useAppDispatch();
  const tagMutationMap = {
    genre: useCreateGenreTag,
    feeling: useCreateFeelingTag,
  };

  const createTagMutation =
    (tagType && tagMutationMap[tagType]?.()) || useCreateTagMutation();

  const { addNotification } = useNotification();
  const onSubmit = async (formData: { title: string }) => {
    if (!tagType) return alert("Please provide a tag type");
    onConfirm(formData);
    createTagMutation.mutateAsync(
      { title: watch("title") },
      {
        onSuccess: () => {
          addNotification("Success creating tag!", "success");
          dispatch(setCreateTagModalOpen(false));
          dispatch(setRefetchTagsByTagType(tagType));
          dispatch(setTagTypeToCreate(undefined));
          reset();
        },
        onError: () => {
          addNotification("Error creating tag!", "error");
          reset();
        },
      }
    );
  };

  return (
    <UIModal
      actions={[
        <UIButton key="cancel" onClick={closeModal} variant="outline">
          Cancel
        </UIButton>,
        <UIButton
          type="submit"
          key="delete"
          onClick={handleSubmit(onSubmit)}
          variant="primary"
        >
          Submit
        </UIButton>,
      ]}
      isOpen={isOpen}
      title={`Create ${tagType} tag`}
      onClose={closeModal}
    >
      <div
        style={{
          width: 300,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            errors={errors}
            label="Title"
            name="title"
            placeholder="Title"
          />
        </form>
      </div>
    </UIModal>
  );
};

export default CreateTagModal;
